import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
            <div className="lg:col-span-2">
              <a href="#hero" className="flex items-center gap-2 mb-4 no-underline">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-fire-line text-background-50 text-lg"></i>
                </span>
                <span className="text-[16px] font-bold text-background-50 font-heading">
                  51吃瓜网
                </span>
              </a>
              <p className="text-[13px] text-background-400 leading-relaxed max-w-[420px]">
                {footerData.intro}
              </p>
            </div>

            {footerData.sections.map((section) => (
              <div key={section.title}>
                <h4 className="text-[14px] font-semibold text-background-100 mb-4 font-heading">
                  {section.title}
                </h4>
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        className="text-[13px] text-background-400 hover:text-accent-400 transition-colors no-underline whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-800 pt-8">
            <div className="mb-6">
              <h4 className="text-[13px] font-semibold text-background-400 mb-3">
                {footerData.partners.title}
              </h4>
              <div className="h-10 flex items-center">
                <span className="text-[12px] text-background-600">
                  合作伙伴招募中，期待您的加入
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-[12px] text-background-500">
                {footerData.copyright}
              </p>
              <p className="text-[12px] text-background-600">
                本站内容仅供娱乐参考，请理性看待
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}